/*
* Menu
*
* */

import $ from '../util/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

class Menu {

	constructor(window) {
		this.window = window;
		this.state = false;
	}

	init() {
		this.elem = $('[data-menu]');
		this.elemToggle = $('[data-menu-toggle]');
		this.hamburger = this.elemToggle.filter( function() { return $(this).hasClass('hamburger') });
		this.fader = $('[data-menu-fade]');

		// binding
		this.elemToggle.on('click', e => {
			e.preventDefault();
			if (this.state) {
				this.state = false;
				this.close();
			} else {
				this.state = true;
				this.open();
			}
		});
	}

	open() {
		disableBodyScroll( this.elem );
		this.hamburger.addClass('hamburger--active');
		this.animate('open');
	}

	close() {
		enableBodyScroll( this.elem );
		this.hamburger.removeClass('hamburger--active');
		this.animate('close');
	}

	animate(condition) {
		if ( condition === 'open' ) {
			this.elem.animate({
				'margin-left': 0
			}, {
				duration: 800,
				begin: function (elem) {
					elem.css('display', '');
				},
				complete: () => this.fade()
			});
		} else if ( condition === 'close' ) {
			this.elem.animate({
				'margin-left': window.innerWidth
			}, {
				duration: 800,
				complete: function (elem) {
					elem.css('display', 'none');
				},
				begin: () => this.fade()
			});
		}
	}

	fade() {
		if ( this.fader.length <= 0 ) return;
		if ( this.state ) this.fader.addClass('header__fader_active');
		else this.fader.removeClass('header__fader_active');
	}
}

const menu = new Menu(window);

export default {
	name: 'Menu',
	Menu: menu,
	on: {
		'interactive': function () {
			this.Menu.init();
		}
	}
};